import React from "react";
import styles from "./videocall.module.scss";
//import Videocallimg from "../../../../styles/images/pic-4.png";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";
import { profileDetails } from "../../../../models/model";
import { closeVideoCallRinging } from "../../../../base/utils";

import { sendCancelVideoCallRequest, sendDirectCancelVideoCallRequest, sendDirectVideoCallAccept, sendVideoCallAccept } from "../../../../base/callService/callService";
import { updateMeetingRead, updateMeetingTotalBatch } from "../../../../base/meetingService/apiService";
import store from "../../../../context/store/store";
import { Types } from "../../../../context/action/action";
export default function VideoMeetRequestwindow() {
  let { videomeetingDetails, isDirectVideocall}: profileDetails = useSelector((state: any) => state.profileReducer);
  console.log("videomeetingDetails >>>>>>>", videomeetingDetails);

 const AcceptVideo = (param:any) => {

    console.log("Accept Video calling");
   

    if(param === "joined"){
      if(isDirectVideocall) { 
        store.dispatch({
          type: Types.VIDEOMEET_COUNT_STATUS,
          payload: {
            meetingCountStatus:true
          }
        })
        sendDirectVideoCallAccept(videomeetingDetails,param)
        updateMeetingRead(videomeetingDetails?.meetingDetails?.uuid);
        
      }
      else {
        sendVideoCallAccept(videomeetingDetails )
        store.dispatch({
          type: Types.VIDEOMEET_COUNT_STATUS,
          payload: {
            meetingCountStatus:true
          }
        })
        updateMeetingRead(videomeetingDetails?.meetingDetails?.uuid);
        // updateMeetingTotalBatch();
        
      };
    }else{
      if(isDirectVideocall){sendDirectCancelVideoCallRequest(videomeetingDetails.meetingDetails) 
        store.dispatch({
          type: Types.VIDEOMEET_COUNT_STATUS,
          payload: {
            meetingCountStatus:true
          }
        })
        updateMeetingRead(videomeetingDetails?.meetingDetails?.uuid);
        // updateMeetingTotalBatch();
        
      }
      else {sendCancelVideoCallRequest(videomeetingDetails.meetingDetails)

        store.dispatch({
          type: Types.VIDEOMEET_COUNT_STATUS,
          payload: {
            meetingCountStatus:true
          }
        })
        updateMeetingRead(videomeetingDetails?.meetingDetails?.uuid);
        
      }
      
    }
 
};

  return (
    <>
      <Draggable bounds="parent"><div className={styles.videocallScreenright}>
        <div className={styles.dialpadHeader}>
          <div className={styles.calltiming}><p>Video Calling…<span>HD</span></p></div>
        </div>
        <div className={styles.videocallimguserbdy}>
          {/* <div className={styles.videocallimg}>
            <img src={Videocallimg} alt="videoimg" />
          </div> */}
          <div className={styles.videocallimgUSer}>
            <span>{videomeetingDetails.meetingDetails?.hostName?.charAt(0)}</span>
          </div>
          <div className={styles.callpadbottom}>
            <div className={styles.leftcontent}>
              <h4>{videomeetingDetails.meetingDetails?.hostName}</h4>
              <p className={styles.Exenum}>is inviting to the video meeting</p>
            </div>
            <ul>
              <li onClick={()=>AcceptVideo('')}> <span className={`icon_receiverfill ${styles.videoicon}`}></span></li>
              <li onClick={()=>AcceptVideo('joined')}> <span className={`icon_meet ${styles.callicon}`}></span></li>
            </ul>
          </div>
        </div>
      </div>
      </Draggable>
    </>
  );
};